import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { courseService } from "../../_services";
import Charts, {
  DashboardCombineChart,
  DashboardLine,
  DashboardSchool,
} from "./assets/chartComponent/DashboardCharts";
import UserAvatar from "./UserAvatar/UserAvatar";

import "./dashboard.scss";
import { AuthorizedWrapper } from "../Other/AuthorizedWrapper";
// import CourseList from "../../Teachers/CourseList";
// import TeacherAdminData from "./TeacherAdminData";
import Pdf from "react-to-pdf";
// import AdminListData from "./AdminListData";
// import InstructorListData from "./InstructorListData";
// import UpcomingWebinar from "./UpcomingWebinar";
// import DashboardCalendar from "./DashboardCalendar";
// import AdminTableData from "./AdminTableData";
import { useHistory } from "react-router";
import { Loading } from "../Other/Loading";
import AdminListData from "./Admin/AdminListData";
import AdminTableData from "./Admin/AdminTableData";
import TeacherAdminData from "./Admin/TeacherAdminData";
import InstructorListData from "./Instructor/InstructorListData";
import UpcomingWebinar from "./Instructor/UpcomingWebinar";
import StudentDashboard from "./StudentDashboard";
import DashboardCalendar from "./DashboardCalendar";
// import StudentDashboard from "./StudentDashboard";
function Dashboard(props) {
  const [fetchrecord, setFetchRecord] = useState();
  const [fetchRes, setFetchRes] = useState(false);
  const ref = useRef();
  const history = useHistory();

  const quickStats = [
    { name: "New Course", action: "/dashboard/Course" },
    { name: "New Students", action: "/dashboard/studentList" },
    { name: "New Instructor", action: "/dashboard/instructorList" },
    { name: "Total Payment Transactions", action: "" },
    { name: "Total Webinar", action: "" },
    { name: "B2B Inquiry", action: "" },
  ];

  const accouncements = [
    {
      name: "Pellentesque mi dui, egestas sit amet risus ut",
      lastUpdate: "05-12-22",
      time: "06:02:04",
    },
    {
      name: "Curabitur et nunc libero. Aliquam euismod maximus magna",
      time: "06:02:04",
      lastUpdate: "28-11-22",
    },
    {
      name: "Morbi quis accumsan diam integer convallis eros",
      time: "06:02:04",
      lastUpdate: "03-12-22",
    },
    {
      name: "Maecenas tristique enim eget risus lobortis ",
      time: "06:02:04",
      lastUpdate: "04-12-22",
    },
  ];

  const statistics = () => {
    if (props.user.role === 3) {
      courseService
        .userStatics()
        .then((res) => {
          setFetchRecord(res.data.data);
          setFetchRes(false);
        })
        .catch((res) => {
          console.log(res);
        });
    }
  };

  useEffect(() => {
    setFetchRes(true);
    statistics();
    sessionStorage.clear();
  }, []);
  const options = {
    orientation: "landscape",
    unit: "in",
    format: [8, 9],
  };

  const totalUsers = 100;

  return props.user ? (
    <div className="container-wrapper">
      <AuthorizedWrapper authorizedRoles={["Admin"]}>
        <div ref={ref}>
          <div className="dashboard-container-new">
            <p>Enterprise Dashboard</p>
            <div>
              <button className="lastmonth-btn">Last Month</button>
            </div>
          </div>
          <div className="dashboard-main">
            <div className="flex-80">
              <AdminListData />

              <div className="dashboard-main">
                <div className="flex-chart-60">
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <div className="flex-selectbox-new">
                        <p className="paragraph-css">
                          Actual revenue, Instructor revenue & Admin revenue
                        </p>
                        <select>
                          <option>2022</option>
                        </select>
                      </div>
                      <DashboardCombineChart />
                    </div>
                  </div>
                </div>
                <div className="flex-chart-40">
                  <div className="margin-top-new-01">
                    <div className="flex-new-auto">
                      <div className="box-shadow-new-01 width-new-auto-1">
                        <DashboardLine chartTitle="Registration" />
                      </div>
                      <div className="box-shadow-new-01 width-new-auto">
                        <DashboardSchool chartTitle="Schools" />
                      </div>
                    </div>
                  </div>
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <p className="paragraph-css">
                        Pending Instructor,Student and Course
                      </p>
                      <Charts />
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-main">
                <div className="flex-30">
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <p className="paragraph-css">Active Users By Country</p>
                      <img
                        src="https://th.bing.com/th/id/OIP.f-_vFi-fMUP8FT-TBcoengHaE6?pid=ImgDet&rs=1"
                        width={"100%"}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-70">
                  <AdminTableData />
                </div>
              </div>
            </div>
            <div className="flex-20">
              <div className="box-shadow-new-01">
                <p className="paragraph-css">Recently added Instructor</p>
                <TeacherAdminData />
                <div className="margin-upper-new">
                  <p className="paragraph-css-0">Quick Stats</p>
                  {quickStats.map((item, index) => (
                    <div className="avator-padding-bottom" key={index}>
                      <div className="new-profile-flex">
                        <p className="font-custom-p">{item.name}</p>
                      </div>
                      <div>
                        <img
                          className="img-link-new"
                          src="https://www.pngfind.com/pngs/m/683-6838012_transparent-link-clipart-external-link-icon-white-hd.png"
                          onClick={() => history.push(item.action)}
                        ></img>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Instructor"]}>
        <div ref={ref}>
          <div className="dashboard-container-new">
            <p>Dashboard</p>
            <div>
              <button className="lastmonth-btn">Last Month</button>
            </div>
          </div>
          <div className="dashboard-main">
            <div className="flex-80">
              <InstructorListData />

              <div className="dashboard-main">
                <div className="flex-chart-60">
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <div className="flex-selectbox-new">
                        <p className="paragraph-css">Total Revenue</p>
                        <select>
                          <option>2022</option>
                        </select>
                      </div>
                      <DashboardCombineChart instructor={true} />
                    </div>
                  </div>
                </div>
                <div className="flex-chart-40">
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01 ">
                      <DashboardLine
                        chartTitle="Enrollment"
                        instructor={true}
                      />
                    </div>
                  </div>
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <DashboardSchool
                        chartTitle="Webinar By Month"
                        instructor={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-main">
                <div className="flex-30">
                  <div className="margin-top-new-01">
                    <UpcomingWebinar />
                  </div>
                </div>
                <div className="flex-70">
                  <div className="margin-top-new-01">
                    <div className="box-shadow-new-01">
                      <p className="paragraph-css">Announcements List</p>
                      <div>
                        <table className="table-width-100">
                          <thead>
                            <tr>
                              <td></td>
                              <td>Date</td>
                              <td>Time</td>
                            </tr>
                          </thead>
                          <tbody>
                            {accouncements.map((item, index) => (
                              <tr key={index}>
                                <td className="cell">{item.name}</td>
                                <td className="cell">{item.lastUpdate}</td>
                                <td className="cell">{item.time}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-20">
              <div className="box-shadow-new-01">
                <p className="paragraph-css">Recently added Students</p>
                <TeacherAdminData instructor={true} />
                <div className="margin-upper-new">
                  <p className="paragraph-css-0">Event Calendar</p>
                  <DashboardCalendar />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Institute"]}>
        <>
          {/* <div className="welcome-screen">
            <div className="wel-left">
              <UserAvatar styleName="dashboard" />
            </div>
            <div className="wel-right">
              <div className="card-title admin-card">
                <div>USER ACCOUNT COUNT : {`${totalUsers}`}</div>
              </div>
              <div className="title">Hi,{props.user.firstName}</div>
              <div className="description admin-card-name">
                ENTERPRISE DASHBOARD
              </div>
            </div>
            <div className="wel-extreme-right">
              <div>
                <div className="card-title admin-card">WEBINARS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.webinars}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">COURSES</div>
                <div className="card-count">
                  <span className="percent admin-card">
                    {fetchrecord && fetchrecord.courses}
                  </span>
                </div>
              </div>
              <div>
                <div className="card-title admin-card">ADMINS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.moderation}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">INSTRUCTORS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.instructors}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">STUDENTS</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.students}
                </div>
              </div>
              <div>
                <div className="card-title admin-card">MODERATION</div>
                <div className="card-count admin-card">
                  {fetchrecord && fetchrecord.moderation}
                </div>
              </div>
            </div>
          </div> */}

          <div ref={ref}>
            <div className="dashboard-container-new">
              <p>Enterprise Dashboard</p>
              <div>
                <button className="lastmonth-btn">Last Month</button>
                <Pdf
                  targetRef={ref}
                  filename="Dashboard.pdf"
                  options={options}
                  x={0.5}
                  y={0.5}
                  scale={0.8}
                >
                  {({ toPdf }) => (
                    <button className="export-btn" onClick={toPdf}>
                      Export
                    </button>
                  )}
                </Pdf>
              </div>
            </div>
            <div className="dashboard-main">
              <div className="flex-80">
                <AdminListData />

                <div className="dashboard-main">
                  <div className="flex-chart-60">
                    <div className="margin-top-new-01">
                      <div className="box-shadow-new-01">
                        <div className="flex-selectbox-new">
                          <p className="paragraph-css">
                            Actual revenue, Instructor revenue & Admin revenue
                          </p>
                          <select>
                            <option>2022</option>
                          </select>
                        </div>
                        <DashboardCombineChart />
                      </div>
                    </div>
                  </div>
                  <div className="flex-chart-40">
                    <div className="margin-top-new-01">
                      <div className="flex-new-auto">
                        <div className="box-shadow-new-01 width-new-auto-1">
                          <DashboardLine chartTitle="Registration" />
                        </div>
                        <div className="box-shadow-new-01 width-new-auto">
                          <DashboardSchool chartTitle="Schools" />
                        </div>
                      </div>
                    </div>
                    <div className="margin-top-new-01">
                      <div className="box-shadow-new-01">
                        <p className="paragraph-css">
                          Pending Instructor,Student and Course
                        </p>
                        <Charts />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dashboard-main">
                  <div className="flex-30">
                    <div className="margin-top-new-01">
                      <div className="box-shadow-new-01">
                        <p className="paragraph-css">Active Users By Country</p>
                        <img
                          src="https://th.bing.com/th/id/OIP.f-_vFi-fMUP8FT-TBcoengHaE6?pid=ImgDet&rs=1"
                          width={"100%"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex-70">
                    <AdminTableData />
                  </div>
                </div>
              </div>
              <div className="flex-20">
                <div className="box-shadow-new-01">
                  <p className="paragraph-css">Recently added Instructor</p>
                  <TeacherAdminData />
                  <div className="margin-upper-new">
                    <p className="paragraph-css-0">Quick Stats</p>
                    {quickStats.map((item, index) => (
                      <div className="avator-padding-bottom" key={index}>
                        <div className="new-profile-flex">
                          <p className="font-custom-p">{item.name}</p>
                        </div>
                        <div>
                          <img
                            className="img-link-new"
                            src="https://www.pngfind.com/pngs/m/683-6838012_transparent-link-clipart-external-link-icon-white-hd.png"
                            onClick={() => history.push(item.action)}
                          ></img>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <CourseList role={props.user.role} /> */}
        </>
      </AuthorizedWrapper>

      <AuthorizedWrapper authorizedRoles={["Student"]}>
        <StudentDashboard />
      </AuthorizedWrapper>
    </div>
  ) : (
    <Loading />
  );
}
function mapStateToProps(state) {
  const { loggedIn, user } = state.users;
  return {
    loggedIn,
    user,
  };
}
const connectedDashboard = connect(mapStateToProps)(Dashboard);
export default connectedDashboard;
